import { render } from "./TotalBalance.vue?vue&type=template&id=bccdc1b8"
import script from "./TotalBalance.vue?vue&type=script&lang=js"
export * from "./TotalBalance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__